<script setup lang="ts">
import type { Schemas } from "#shopware";
import {
  getSmallestThumbnailUrl,
  getTranslatedProperty
} from "@shopware/helpers";
import {computed} from "vue";
import { useElementVisibility } from '@vueuse/core'
const viewport = await useViewport()

const { pushSuccess, pushError } = useNotifications();
const props = defineProps<{
  product: Schemas["Product"],
  products: any,
  isBundle: Boolean,
}>();

const { product, isBundle } = toRefs(props);
const productName = computed(() =>
    getTranslatedProperty(props.product, "name"),
);
const { getErrorsCodes } = useCartNotification();
const { t } = useI18n();
const { addToCart, quantity } = useAddToCart(product);
const miniCartController = useModal();

const target = ref(null);
const targetIsVisible = useElementVisibility(target);

const srcPath = computed(() => {
  let imageUrl = getSmallestThumbnailUrl(
      product.value?.cover?.media,
  );
  if(imageUrl) {
    return `${getSmallestThumbnailUrl(
        product.value?.cover?.media,
    )}`;
  }

  imageUrl = product.value?.cover?.media?.url
  if(imageUrl) {
    return imageUrl;
  }
  return null;
});

const loading = ref(true);
onMounted(() => {
  loading.value = false;
});
</script>

<template>

  <SharedModal :controller="miniCartController" popup-class="checkout-side-cart" size="modal-xl">
    <CheckoutSideCart
        class="mini-cart"
        :controller="miniCartController"
        @close="miniCartController.close"
        @success="miniCartController.close"
        :successMessage="`<b>` + $t('product.product') + `</b>` + $t('product.messages.addedToCart')"
    />
  </SharedModal>

  <div ref="target">
    <div class="sticky-add-to-cart-wrapper" v-if="product.availableStock > 0 && !targetIsVisible">
      <div class="container">
        <div class="flex">
          <div class="">
            <div class="card__image d-none d-md-block">
              <img v-if="srcPath && srcPath.substring(srcPath.length - 3) !== 'jpg'" class="product-img" src="/assets/images/product-image-bg.jpg"  alt="bg"/>

              <NuxtImg
                  class="product-img-cover"
                  fit="cover"
                  :src="srcPath ? srcPath : ''"
                  preset="listing"
                  loading="lazy"
                  data-testid="product-box-img"
                  :class="{
                  'no-hover': (srcPath && srcPath.substring(srcPath.length - 3) === 'jpg')
                }"
                  :alt="productName || ''"

                  ref="imageElement"
              >
              </NuxtImg>
            </div><!-- /.card__image -->
          </div>
          <div class="grow">
            <span class="product-name" v-html="productName" />
            <div class="d-none d-md-block" style="margin-left:15px;margin-top:-10px;width:150px;">
              <etrusted-widget class="d-none d-md-block w-20" data-etrusted-widget-id="wdg-51651cc8-579d-4d1c-a309-adbbc381420b"></etrusted-widget>
            </div>


          </div>
          <div><ProductPrice :product="product" /></div>

          <div>
            <ProductAddToCart v-if="!isBundle" :product="product"></ProductAddToCart>
            <ProductAddBundleToCart v-if="isBundle" :products="products"></ProductAddBundleToCart>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
